import React, { useEffect, useRef } from "react";
import "../Style/Linkshare.css";

/* ------------------------------------------------------------------
   ADD YOUR PICTURES HERE
   Import three screenshots and drop them into DEFAULT_SCREENS.
   Best size: portrait, roughly 1080 x 2300 px (any phone screenshot works).

     import shotLeft from "../assets/phone-left.png";
     import shotCenter from "../assets/phone-center.png";
     import shotRight from "../assets/phone-right.png";
     const DEFAULT_SCREENS = { left: shotLeft, center: shotCenter, right: shotRight };

   Leave a slot as null to show the built-in placeholder screen.
   You can also pass them as a prop: <LinkShareSection screens={{ center: pic }} />
------------------------------------------------------------------- */
const DEFAULT_SCREENS = { left: null, center: null, right: null };

function Placeholder({ variant }) {
  return (
    <div className={`mlink-ph mlink-ph--${variant}`}>
      <span className="mlink-ph__avatar" />
      <span className="mlink-ph__line mlink-ph__line--a" />
      <span className="mlink-ph__line mlink-ph__line--b" />
      <span className="mlink-ph__btn mlink-ph__btn--solid" />
      <span className="mlink-ph__btn" />
      <span className="mlink-ph__btn" />
    </div>
  );
}

function Phone({ variant, src }) {
  return (
    <div className={`mlink-phone mlink-phone--${variant}`}>
      <span className="mlink-phone__btn mlink-phone__btn--l1" />
      <span className="mlink-phone__btn mlink-phone__btn--l2" />
      <span className="mlink-phone__btn mlink-phone__btn--r" />
      <div className="mlink-phone__screen">
        {src ? (
          <img src={src} alt="" draggable="false" loading="lazy" />
        ) : (
          <Placeholder variant={variant} />
        )}
        <span className="mlink-phone__island" />
        <span className="mlink-phone__glare" />
      </div>
    </div>
  );
}

// onOpenAuth: (mode: "signin" | "signup") => void — same shared handler
// used by Navbar, Hero, and CreateCustomize.
export default function LinkShareSection({
  onOpenAuth,
  screens = DEFAULT_SCREENS,
}) {
  const sectionRef = useRef(null);

  // Plays the entrance when the section scrolls into view and resets once it
  // has fully left the screen, so it replays on the next visit.
  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      node.classList.add("is-in");
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.3) {
          node.classList.add("is-in");
        } else if (entry.intersectionRatio === 0) {
          node.classList.remove("is-in");
        }
      },
      { threshold: [0, 0.3] }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const s = { ...DEFAULT_SCREENS, ...screens };

  return (
    <section className="mlink-share" ref={sectionRef}>
      <div className="mlink-share__inner">
        <div className="mlink-share__copy">
          <h2 className="mlink-share__headline">
            Share your MLink
            <br />
            anywhere you like!
          </h2>
          <p className="mlink-share__sub">
            Add your unique MLink URL to every platform and place you find
            your audience. Then use your QR code to bring your offline
            traffic back to your link in bio.
          </p>
          <button
            type="button"
            className="mlink-share__cta"
            onClick={() => onOpenAuth("signup")}
          >
            Get started for free
          </button>
        </div>

        <div className="mlink-share__stage" aria-hidden="true">
          <Phone variant="left" src={s.left} />
          <Phone variant="center" src={s.center} />
          <Phone variant="right" src={s.right} />
        </div>
      </div>
    </section>
  );
}